module.exports = __webpack_public_path__ + "static/media/question.9fb2c926.png";